<template>
  <div class="d-flex justify-center">
    <NewOffer
      @close="closeDialog"
      :currentBooking="currentBooking"
      :isOpen="isOpen"
      v-if="isOpen"
    />
    <SecondaryButton @click.native="openDialog" color="primary">
      <div class="d-flex align-center justify-center">
        <svg
          width="28"
          height="28"
          viewBox="0 0 29 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.618 0H3C1.34315 0 0 1.34315 0 3V32.5C0 34.1569 1.34314 35.5 3 35.5H25.4C27.0569 35.5 28.4 34.1569 28.4 32.5V9.84996L18.618 0Z"
            />
          </mask>
          <path
            d="M18.618 0L20.0371 -1.40931L19.4505 -2H18.618V0ZM28.4 9.84996H30.4V9.02558L29.8191 8.44065L28.4 9.84996ZM3 2H18.618V-2H3V2ZM2 3C2 2.44772 2.44772 2 3 2V-2C0.238576 -2 -2 0.238577 -2 3H2ZM2 32.5V3H-2V32.5H2ZM3 33.5C2.44772 33.5 2 33.0523 2 32.5H-2C-2 35.2614 0.238571 37.5 3 37.5V33.5ZM25.4 33.5H3V37.5H25.4V33.5ZM26.4 32.5C26.4 33.0523 25.9523 33.5 25.4 33.5V37.5C28.1614 37.5 30.4 35.2614 30.4 32.5H26.4ZM26.4 9.84996V32.5H30.4V9.84996H26.4ZM29.8191 8.44065L20.0371 -1.40931L17.1989 1.40931L26.9809 11.2593L29.8191 8.44065Z"
            fill="white"
            mask="url(#path-1-inside-1)"
          />
          <path
            d="M8 26C10.8733 22.409 16.2593 11.3921 12.9755 10.1153C8.87076 8.51932 5.12667 24.005 11.6943 24.803C18.2619 25.601 20.726 19.5776 19.4946 18.7796C19.2422 18.616 16.4868 16.3729 15.4838 19.261C14.3403 22.554 16.4848 24.0048 21 26"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Offer
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewOffer from "@/views/bookings/Offers/components/NewOffer";

export default {
  name: "AddOfferAction",
  props: {
    currentBooking: { type: Object, required: true }
  },
  components: {
    SecondaryButton,
    NewOffer
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
